import { ModalDataRecord } from './modal-data-record';

export type ModalData = ModalDataRecord | string | number | null;
